var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuests(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 9.9447C16.6663 11.5648 15.2738 12.9226 13.4997 12.9226C11.7255 12.9226 10.333 11.5648 10.333 9.9447C10.333 8.32462 11.7255 6.9668 13.4997 6.9668C15.2738 6.9668 16.6663 8.32462 16.6663 9.9447Z",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18.0101V20.2479C8 20.8002 8.44436 21.2478 8.99664 21.2478H18.0013C18.5536 21.2478 19 20.8002 19 20.2479V17.7699C19 16.2591 17.4796 14.9021 16.1522 14.4506C15.6063 14.265 15.039 14.4621 14.4811 14.6076C14.2162 14.6766 13.894 14.7267 13.5 14.7267C12.8902 14.7267 12.3202 14.6067 11.9557 14.4823C11.6932 14.3927 11.4092 14.2831 11.1348 14.3233C9.05739 14.6277 8 17.0707 8 18.0101Z",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuests);
export default __webpack_public_path__ + "static/media/guests.f92690e98bbdb3acfd52cdaecd20bb98.svg";
export { ForwardRef as ReactComponent };